import React, { useId } from "react";

/**
 * Campo de texto base del sistema de UI.
 * Props:
 *  - label: etiqueta superior opcional
 *  - error: mensaje de error (pinta el campo en rojo)
 *  - helperText: texto de ayuda bajo el campo (se oculta si hay error)
 *  - required: agrega asterisco a la etiqueta
 *  - id: id del input (se genera uno si no se pasa)
 *  - Resto de props se pasan directo al <input>
 */
const Input = React.forwardRef(function Input(
  {
    label,
    error,
    helperText,
    required = false,
    id,
    className = "",
    ...rest
  },
  ref
) {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <div className="sw-ui-field">
      {label && (
        <label htmlFor={inputId} className="sw-plbl">
          {label}
          {required && <span className="sw-ui-field-required"> *</span>}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        required={required}
        className={`sw-pinput sw-ui-input ${error ? "sw-ui-input--error" : ""} ${className}`}
        aria-invalid={!!error}
        aria-describedby={error || helperText ? `${inputId}-hint` : undefined}
        {...rest}
      />
      {(error || helperText) && (
        <p
          id={`${inputId}-hint`}
          className={`sw-ui-field-hint ${error ? "sw-ui-field-hint--error" : ""}`}
        >
          {error || helperText}
        </p>
      )}
    </div>
  );
});

export default Input;
